"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorHash = void 0;
exports.hash = hash;
var tslib_1 = require("tslib");
var color_hash_1 = tslib_1.__importDefault(require("color-hash"));
var CH = new color_hash_1.default({ hash: 'bkdr', saturation: [0.65, 0.35, 0.5], lightness: [0.65, 0.35, 0.5] });
var COLOR_HASHES = {};
function hash(id) {
    var color = COLOR_HASHES[id];
    if (color == null) {
        color = COLOR_HASHES[id] = CH.hex(id);
    }
    return color;
}
exports.ColorHash = { hash: hash };
//# sourceMappingURL=color.hash.js.map